module.exports = __webpack_public_path__ + "static/a3-04bedba294e8ec68098360fb91f92802.jpg";